import firebase from "firebase/app";

export const roleCollectionKey = "roles";

export type RoleType = "student" | "tutor" | "admin";

export type Role = {
  ref: firebase.firestore.DocumentReference;
  data: RoleData;
};

export type RoleData = {
  ref: firebase.firestore.DocumentReference;
  type: RoleType;
  isPrivateTutor?: boolean; // サーバーがスタッフ権限変更時に同期するアクセス制限用マーカー
  privateTutorMessagingAllowed?: boolean; // tutorConfig と同時に同期する Storage Rules 用のメッセージ送信権限。true の場合のみ許可
  loginId?: string;
  code?: string;
  gmail?: string;
  microsoftEmail?: string;
};

export function convertToRole(
  data: firebase.firestore.DocumentData,
  ref: firebase.firestore.DocumentReference
): Role {
  const returnData: RoleData = {
    ref: data.ref,
    type: data.type
  };
  if (typeof data.isPrivateTutor === "boolean") {
    returnData.isPrivateTutor = data.isPrivateTutor;
  }
  if (typeof data.privateTutorMessagingAllowed === "boolean") {
    returnData.privateTutorMessagingAllowed = data.privateTutorMessagingAllowed;
  }
  if (data.loginId) {
    returnData.loginId = data.loginId;
  }
  if (data.code) {
    returnData.code = data.code;
  }
  if (data.gmail) {
    returnData.gmail = data.gmail;
  }
  if (data.microsoftEmail) {
    returnData.microsoftEmail = data.microsoftEmail;
  }

  return {
    ref,
    data: returnData
  };
}
